import React from 'react';
import { NewsIcon } from 'taboola-ultimate-ui';
import { ContextualSegmentsField } from 'modules/campaigns/modules/common-campaign-form/components/ContextualSegments/ContextualSegmentsField';
import { CustomContextualSegmentsField } from 'modules/campaigns/modules/common-campaign-form/components/CustomContextualSegments/CustomContextualSegmentsField';
import { SegmentsTargetingSection } from './SegmentsTargetingSection';

export const ContextualTargetingSection = ({ isInitiallyCollapsed }) => {
    return (
        <SegmentsTargetingSection
            sectionId="CAMPAIGN_CONTEXTUAL_TARGETING"
            titleMessageId="campaign.editor.contextual.targeting"
            descriptionMessageId="campaign.editor.contextual.targeting.description"
            isShowTooltip={false}
            headerIcon={<NewsIcon />}
            isInitiallyCollapsed={isInitiallyCollapsed}
        >
            <ContextualSegmentsField messagePrefix="new." />
            <CustomContextualSegmentsField />
        </SegmentsTargetingSection>
    );
};
